/* tslint:disable */
/* eslint-disable */
/**
 * AddressCheckPublic API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type { IsoCountryCodeEnum } from '../models/index';
import { IsoCountryCodeEnumFromJSON } from '../models/index';

/**
 *
 */
export class SelectOptionsApi extends runtime.BaseAPI {
  /**
   */
  async getIsoCountryCodesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<IsoCountryCodeEnum>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken(
        'adminAuth',
        []
      );
    }

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('publicAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/public/v1/selectoptions/isocountrycodes`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(IsoCountryCodeEnumFromJSON)
    );
  }

  /**
   */
  async getIsoCountryCodes(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<IsoCountryCodeEnum>> {
    const response = await this.getIsoCountryCodesRaw(initOverrides);
    return await response.value();
  }
}
